export const theme = {
    colors: {
        primary: {
            50: '#f8fafc',
            100: '#f1f5f9',
            500: '#ffffff',
            900: '#0f172a'
        },
        accent: {
            blue: '#3b82f6',
            purple: '#8b5cf6',
            pink: '#ec4899',
            yellow: '#f59e0b'
        },
        background: {
            dark: '#0f172a',
            darker: '#020617',
            card: 'rgba(255, 255, 255, 0.05)'
        },
        text: {
            primary: '#f8fafc',
            secondary: '#cbd5e1',
            muted: '#64748b'
        }
    },
    shadows: {
        card: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        glow: '0 0 20px rgba(59, 130, 246, 0.3)'
    }
}